<mjx-corporate-users-data-form *ngIf="!isPartner"></mjx-corporate-users-data-form>
<mjx-partner-users-data-form *ngIf="isPartner"></mjx-partner-users-data-form>

